export default __webpack_public_path__ + "static/media/clarify_text_main.6c7177c2.svg";